// Config for the Radiance & Full Bloom application forms.
// Question types: text, textarea, radio, checkbox (multi), scale (1-10).

export const APPLICATION_FORMS = {
  radiance: {
    type: "radiance",
    title: "The Radiance Collection",
    tagline: "20 weeks. One you. Fully bloomed.",
    intro: "Radiance is by application only, because real transformation deserves real readiness. Answer honestly, and let's see if this season is yours.",
    questions: [
      { id: "commit_20w", type: "radio", required: true,
        label: "Can you stick with us for 20 weeks to change your mind, body, and soul?",
        options: ["Yes, I'm all in", "I want to, but I'm a little nervous", "I'm curious, tell me more"] },
      { id: "calling", type: "textarea", required: true,
        label: "What's calling you to Radiance right now?",
        placeholder: "Tell me what's stirring in your heart today." },
      { id: "focus", type: "checkbox", required: false,
        label: "Which part of your bloom needs the most love right now? Pick all that fit.",
        options: ["Mind and mindset", "Body and weight", "Energy and hormones", "Confidence and self-worth", "Habits and consistency", "Rest and nervous system"] },
      { id: "readiness", type: "scale", required: true,
        label: "How ready are you to do the work, even on the hard days?",
        low: "Easing in", high: "Let's go" },
      { id: "held_back", type: "textarea", required: false,
        label: "What's held you back before? No judgment here.",
        placeholder: "Old habits, timing, life happening, whatever feels true." },
      { id: "open_care", type: "radio", required: true,
        label: "Are you open to weekly telehealth visits, lab work, and a personalized plan?",
        options: ["Yes, absolutely", "Mostly yes, with a few questions", "I'd like to learn more first"] },
      { id: "future_self", type: "textarea", required: false,
        label: "Picture yourself 20 weeks from now, fully radiant. What does she look and feel like?",
        placeholder: "Describe her, she's already in there." },
    ],
  },
  fullbloom: {
    type: "fullbloom",
    title: "The Full Bloom Collection",
    tagline: "52 weeks to 18 months. We commit to you, you commit to us.",
    intro: "Full Bloom is the couture experience for the woman who is done playing small. It asks for real change, real modifications, and real devotion, and in return we stay with you until you become Her. Let's make sure you're ready.",
    questions: [
      { id: "ready_become_her", type: "radio", required: true,
        label: "Full Bloom is a deep, long-term journey of transformation. Are you ready to commit fully to becoming Her?",
        options: ["Yes, I'm ready to become Her", "I want this, but I need to understand more", "I'm exploring if the timing is right"] },
      { id: "modifications", type: "checkbox", required: true,
        label: "This journey asks for real modifications to your daily life. Which are you willing to embrace?",
        options: ["Nutrition and ShapeUp", "Daily movement", "Sleep and true rest", "Mindset and neuroplasticity work", "Supplements and lab work", "Weekly practitioner visits", "Boundaries and self-care"] },
      { id: "true_self", type: "textarea", required: true,
        label: "What does your true self, your fully bloomed Her, look like?",
        placeholder: "Dream out loud. Who are you becoming?" },
      { id: "change_maintain", type: "textarea", required: true,
        label: "What needs to change, transform, and be maintained for you to keep your glow up for life?",
        placeholder: "Be honest about what it will really take to stay Her." },
      { id: "commit_to_us", type: "radio", required: true,
        label: "We commit to you with full labs, 52+ practitioner hours, workshops, menus, supplements, and retreats. Can you commit to us, to the process, even when it gets uncomfortable?",
        options: ["Yes, I'm committed", "I'm close, let's talk it through"] },
      { id: "maintain_score", type: "scale", required: true,
        label: "How committed are you to maintaining your transformation, not just achieving it?",
        low: "Working on it", high: "Forever Her" },
      { id: "biggest_why", type: "textarea", required: true,
        label: "What's your biggest why? Who are you doing this for?",
        placeholder: "The reason that gets you up on the hard days." },
      { id: "past_programs", type: "textarea", required: false,
        label: "Have you tried other programs before? What happened?",
        placeholder: "Tell me your story so far." },
      { id: "practitioner_note", type: "textarea", required: false,
        label: "Anything you want your practitioner to know before we begin?",
        placeholder: "Optional, your space to share." },
    ],
  },
};
